import React from 'react';
import { SaveToast } from '../../NameMeaning/NameAlsoLike/styled';

export default function SaveNameToast() {
  return (
    <SaveToast>
      <p>Please Save a name first</p>
    </SaveToast>
  );
}
